import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme =>
({
  root: {
    height: "29px",
    borderRadius: "5px",
    backgroundColor: "#fff",
    width: "100%",
  },
  input: {
    display: "flex",
    maxHeight: "29px",
    padding: 5,
  },
  valueContainer: {
    display: "flex",
    // flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    overflow: "hidden",
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
  },
  singleValue: {
    fontSize: 14,
  },
  placeholder: {
    left: 2,
    bottom: 6,
    fontSize: 16,
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(0.5),
    left: 0,
    right: 0,
  },
}))

export default styles
